import { Component, EventEmitter, Input,  Output, Inject } from 'ng-metadata/core';

import './sentiment.menu.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentSentimentMenu
 * @module mw.components.contentDocuments
 * @param {string} [sentiment] - The current sentiment of the document.
 * @param {string} [sentiment-override] - The sentiment of the document, if its ever been overwritten by the user
 * @param {expression} [on-sentiment-update] - Function passed in to handle sentiment when it updates.
 * @param {expression} [on-sentiment-reset] - Function passed in to handle sentiment when the user resets it.
 *  @description
 * `mw-content-document-sentiment-menu` is responsible for showing a single select menu that lists all sentiment value options.
 * @usage
 * <hljs hls-language="html">
 *  <mw-content-document-sentiment-menu sentiment="$ctrl.document.sentiment" sentiment-override="$ctrl.document.sentimentOverride"></mw-content-document-sentiment-menu>
 * </hls>
 */
@Component({
    selector: 'mw-content-document-sentiment-menu',
    template: `
        <md-menu-content class="mw-menu-dropdown" md-padding="md-padding">
            <mw-menu-item type="focusdummy" md-autofocus></mw-menu-item>
            <mw-menu-item class="mw-content-document-sentiment-menu__positive" ng-click="$ctrl.handleSentimentSelect('P')" type="singleselect" is-selected="$ctrl.sentimentOverride === 'P'">{{ 'Positive' | translate }}</mw-menu-item>
            <mw-menu-item class="mw-content-document-sentiment-menu__neutral" ng-click="$ctrl.handleSentimentSelect('N')" type="singleselect" is-selected="$ctrl.sentimentOverride === 'N'">{{ 'Neutral' | translate }}</mw-menu-item>
            <mw-menu-item class="mw-content-document-sentiment-menu__negative" ng-click="$ctrl.handleSentimentSelect('V')" type="singleselect" is-selected="$ctrl.sentimentOverride === 'V'">{{ 'Negative' | translate }}</mw-menu-item>
            <mw-menu-item class="mw-content-document-sentiment-menu__notrated" ng-click="$ctrl.handleSentimentSelect('U')" type="singleselect" is-selected="$ctrl.sentimentOverride === 'U'">{{ 'Not Rated' | translate }}</mw-menu-item>
            <md-divider ng-if="::$ctrl.sentimentOverride"> </md-divider>
            <mw-menu-item class="mw-content-document-sentiment-menu__reset" ng-if="::$ctrl.sentimentOverride" ng-click="$ctrl.handleSentimentReset()" type="singleselect">{{ 'Reset' | translate }}</mw-menu-item>
        </md-menu-content>
    `
})
export class SentimentMenuComponent {
    @Input('<') sentiment: string;
    @Input('<') sentimentOverride: string;

    @Output() onSentimentUpdate = new EventEmitter<string>();
    @Output() onSentimentReset = new EventEmitter();

    constructor(@Inject('$mdPanel') private $mdPanel) {
        'ngInject';
    }

    handleSentimentSelect(sentiment) {
        this.sentimentOverride = sentiment;
        this.onSentimentUpdate.emit(this.sentimentOverride);
    }

    handleSentimentReset() {
        this.onSentimentReset.emit({});
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/sentiment/sentiment.menu.component.ts